import svc = require("./Service");
import $ = require("jquery");
export interface IEventSessionEvaluationResultDto {
    EventSessionId: Guid;
    ErrorStatus: string;
    IsValid: boolean;
    ErrorMessage: string;
    StartDateLocalText: string;
    EndDateLocalText: string;
}
export class Service {
    private serviceUrl: string;
    constructor(serviceUrl?: string) {
        if (serviceUrl) {
            this.serviceUrl = serviceUrl;
        } else {
            var globals = svc.globalPageData();
            this.serviceUrl = globals.urls.validateEventSession;
        }
    }

    validateEventSession(formResponseId: string | Guid, eventSessionId: string | Guid): Promise<IEventSessionEvaluationResultDto> {
        var p = new Promise<IEventSessionEvaluationResultDto>((resolve, reject) => {
            var xhr = $.post(this.serviceUrl, { formResponseId: formResponseId, eventSessionId: eventSessionId });
            xhr.done((result) => {
                    resolve(result);
            }).fail((error) => {
                reject(error);
            });
        });
        return p;
       
    }
}
